import { isEuropeanCountry, normalizeCountryCode } from "../utils/clubAdminOnboarding";
import { EMPTY_SCFORH_SEED } from "../constants/scforhClubHealth";

export const ADMIN_PHASES = ["C", "Y", "H", "A"];

export const ADMIN_PHASE_META = {
  C: { letter: "C", labelKey: "digipingAdminPhaseClub" },
  Y: { letter: "Y", labelKey: "digipingAdminPhaseYou" },
  H: { letter: "H", labelKey: "digipingAdminPhaseHealth" },
  A: { letter: "A", labelKey: "digipingAdminPhaseAccount" },
};

export const STEP_TO_PHASE = {
  invitedClub: "C",
  clubCountry: "C",
  federationAffiliation: "C",
  clubSelection: "C",
  clubProof: "C",
  affiliationInterest: "C",
  adminFirstName: "Y",
  adminLastName: "Y",
  adminPosition: "Y",
  healthIntro: "H",
  scforhSportingAims: "H",
  scforhTargetGroups: "H",
  whoCapsules: "H",
  scforhHealthDimensions: "H",
  scforhIntegration: "H",
  scforhCurrentOffer: "H",
  adminEmail: "A",
  emailConfirmation: "A",
  adminPassword: "A",
};

export const STEP_PROMPT_KEY = {
  invitedClub: "digipingAdminQInvitedClub",
  clubCountry: "digipingAdminQCountry",
  federationAffiliation: "digipingAdminQFederation",
  clubSelection: "digipingAdminQClub",
  clubProof: "digipingAdminQProof",
  affiliationInterest: "digipingAdminQAffiliation",
  adminFirstName: "digipingAdminQFirstName",
  adminLastName: "digipingAdminQLastName",
  adminPosition: "digipingAdminQPosition",
  healthIntro: "digipingAdminQHealthIntro",
  scforhSportingAims: "scforhSportingAims",
  scforhTargetGroups: "scforhTargetGroups",
  whoCapsules: "digipingAdminQWhoCapsules",
  scforhHealthDimensions: "scforhHealthDimensions",
  scforhIntegration: "scforhIntegration",
  scforhCurrentOffer: "scforhCurrentOffer",
  adminEmail: "digipingAdminQEmail",
  emailConfirmation: "digipingAdminQEmailConfirm",
  adminPassword: "digipingAdminQPassword",
};

export const MULTI_STEPS = new Set(["scforhTargetGroups", "scforhHealthDimensions"]);

export const EMPTY_ADMIN_FORM = {
  clubName: "",
  clubCountry: null,
  clubCountryCode: "",
  clubCountrySearch: "",
  selectedClub: null,
  clubSearch: "",
  clubNotInList: false,
  federationAffiliated: "",
  adminProofUrl: "",
  adminProofName: "",
  invitationToken: "",
  inviteRole: "",
  clubCity: "",
  clubAddress: "",
  clubPostalCode: "",
  clubPhone: "",
  clubWebsite: "",
  clubDescription: "",
  clubFoundedYear: "",
  clubNumberOfMembers: "",
  clubNumberOfTables: "",
  clubFacilities: [],
  adminFirstName: "",
  adminLastName: "",
  adminEmail: "",
  adminPhone: "",
  adminPosition: "",
  adminExperience: "",
  adminGender: null,
  adminDateOfBirth: null,
  hasExistingScforhProfile: false,
  hasExistingGroups: false,
  scforh: { ...EMPTY_SCFORH_SEED },
};

export const ADMIN_POSITIONS = [
  { id: "president", name: "President", nameFr: "Président", nameDe: "Präsident", nameEs: "Presidente" },
  { id: "vice_president", name: "Vice President", nameFr: "Vice-Président", nameDe: "Vizepräsident", nameEs: "Vicepresidente" },
  { id: "secretary", name: "Secretary", nameFr: "Secrétaire", nameDe: "Sekretär", nameEs: "Secretario" },
  { id: "treasurer", name: "Treasurer", nameFr: "Trésorier", nameDe: "Schatzmeister", nameEs: "Tesorero" },
  { id: "sports_director", name: "Sports Director", nameFr: "Directeur Sportif", nameDe: "Sportdirektor", nameEs: "Director Deportivo" },
  { id: "matches_results", name: "Matches & results", nameFr: "Responsable matchs et résultats", nameDe: "Spiel- und Ergebnisverantwortliche:r", nameEs: "Responsable de partidos y resultados" },
  { id: "youth_director", name: "Youth Director", nameFr: "Directeur Jeunesse", nameDe: "Jugenddirektor", nameEs: "Director Juvenil" },
  { id: "coach", name: "Coach", nameFr: "Entraîneur", nameDe: "Trainer", nameEs: "Entrenador" },
  { id: "head_coach", name: "Head Coach", nameFr: "Entraîneur Principal", nameDe: "Cheftrainer", nameEs: "Entrenador Principal" },
  { id: "club_manager", name: "Club Manager", nameFr: "Gestionnaire du Club", nameDe: "Clubmanager", nameEs: "Gerente del Club" },
  { id: "event_coordinator", name: "Event Coordinator", nameFr: "Coordinateur d'Événements", nameDe: "Veranstaltungskoordinator", nameEs: "Coordinador de Eventos" },
  { id: "marketing_manager", name: "Marketing Manager", nameFr: "Responsable Marketing", nameDe: "Marketingmanager", nameEs: "Gerente de Marketing" },
  { id: "facilities_manager", name: "Facilities Manager", nameFr: "Responsable des Installations", nameDe: "Anlagenmanager", nameEs: "Gerente de Instalaciones" },
  { id: "membership_coordinator", name: "Membership Coordinator", nameFr: "Coordinateur des Membres", nameDe: "Mitgliedskoordinator", nameEs: "Coordinador de Membresía" },
  { id: "communication_officer", name: "Communication Officer", nameFr: "Responsable Communication", nameDe: "Kommunikationsbeauftragter", nameEs: "Oficial de Comunicación" },
  { id: "other", name: "Other", nameFr: "Autre", nameDe: "Andere", nameEs: "Otro" },
];

export function getPositionName(position, lang) {
  if (!position) return "";
  if (lang === "fr") return position.nameFr;
  if (lang === "de") return position.nameDe;
  if (lang === "es") return position.nameEs;
  return position.name;
}

function missingYouSteps(formData) {
  const you = [];
  if (!String(formData?.adminFirstName || "").trim()) you.push("adminFirstName");
  if (!String(formData?.adminLastName || "").trim()) you.push("adminLastName");
  if (!String(formData?.adminPosition || "").trim()) you.push("adminPosition");
  return you;
}

export function getClubAdminSteps(formData) {
  const isInvited = Boolean(formData?.invitationToken);
  const code = formData?.clubCountryCode || normalizeCountryCode(formData?.clubCountry);
  const isEurope = !isInvited && isEuropeanCountry(code);
  const you = ["adminFirstName", "adminLastName", "adminPosition"];
  const isExisting = Boolean(formData?.isExistingAccount);
  const account = isExisting ? ["adminEmail"] : ["adminEmail", "emailConfirmation"];
  const password = ["adminPassword"];

  // Invited admin / committee: club is already known. Skip SCforH questionnaires —
  // the intro covers Sport Clubs for ONE Health; Pingflo can continue after login.
  if (isInvited) {
    return [...missingYouSteps(formData), ...password];
  }

  const steps = ["clubCountry"];
  if (!formData?.clubCountry) return steps;

  if (isEurope) {
    steps.push("federationAffiliation");
    if (formData.federationAffiliated === "yes") {
      steps.push("clubSelection", "clubProof", ...you, ...account, ...password);
    } else if (formData.federationAffiliated === "no") {
      steps.push("affiliationInterest");
    }
    return steps;
  }

  steps.push("clubSelection", ...you, ...account, ...password);
  return steps;
}

export function phaseStatus(formData, currentStep) {
  const steps = getClubAdminSteps(formData);
  const currentIdx = Math.max(0, steps.indexOf(currentStep));
  const status = {};
  ADMIN_PHASES.forEach((phase) => {
    const phaseSteps = steps.filter((id) => STEP_TO_PHASE[id] === phase);
    if (!phaseSteps.length) {
      status[phase] = "empty";
      return;
    }
    const firstIdx = steps.indexOf(phaseSteps[0]);
    const lastIdx = steps.indexOf(phaseSteps[phaseSteps.length - 1]);
    if (currentIdx > lastIdx) status[phase] = "complete";
    else if (currentIdx >= firstIdx) status[phase] = "partial";
    else status[phase] = "empty";
  });
  return status;
}

export function isEuropeWalkIn(formData) {
  if (formData?.invitationToken) return false;
  const code = formData?.clubCountryCode || normalizeCountryCode(formData?.clubCountry);
  return isEuropeanCountry(code);
}

function foldClubNameAnswer(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const CLUB_NOT_LISTED_PHRASES = new Set([
  "i didnt find it",
  "i didnt find my club",
  "i did not find it",
  "i dont find it",
  "i dont see it",
  "i cannot find it",
  "i cant find it",
  "cant find it",
  "cannot find it",
  "didnt find it",
  "dont find it",
  "not in the list",
  "not on the list",
  "not in this list",
  "not on this list",
  "not listed",
  "not in list",
  "no lo encuentro",
  "no la encuentro",
  "no lo encontre",
  "no la encontre",
  "no esta en la lista",
  "no esta en esta lista",
  "no aparece",
  "no aparece en la lista",
  "no esta listado",
  "no lo veo",
  "je ne le trouve pas",
  "pas dans la liste",
  "pas dans cette liste",
  "il nest pas liste",
  "nicht in der liste",
  "nicht in dieser liste",
  "nicht gefunden",
  "niet in de lijst",
  "niet in deze lijst",
  "niet gevonden",
  "nao esta na lista",
  "nao esta nesta lista",
  "nao encontro",
  "nao encontrei",
]);

const CLUB_NOT_LISTED_RE =
  /\b(not (in|on) (the |this )?list|not listed|didnt find|dont find|cant find|cannot find|no (lo|la) encuent(ro|re)|no esta en (la |esta )?lista|no aparece|pas dans (la |cette )?liste|nicht in der liste|niet in de(ze)? lijst|nao esta na lista|nao encontro)\b/;

/** True when the typed answer is “not in the list”, not a club name. */
export function looksLikeClubNotListed(value) {
  const text = foldClubNameAnswer(value);
  if (!text || text.length > 80) return false;
  if (CLUB_NOT_LISTED_PHRASES.has(text)) return true;
  return CLUB_NOT_LISTED_RE.test(text);
}
